var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "38px",
    viewBox: "0 0 44 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2B602EC5-32BA-4D91-93AD-0C10133A2C26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Post-login-(Desktop)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agent-Portal---Desktop---Landing",
    transform: "translate(-274.000000, -164.000000)",
    fill: "#003DA5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quick-Quote",
    transform: "translate(30.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "This-Document/Cards/Quick-Quote-Copy-4",
    transform: "translate(229.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(15.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8534903,7.8651274 C46.8266397,16.4620646 40.4392107,26.2030858 24.2221336,37.1486206 C23.8155214,37.4230589 23.2854283,37.3889649 22.9140529,37.0644887 L12.9673355,28.3738909 C12.4989622,27.964666 12.4365592,27.2359358 12.8279544,26.7462262 C13.2193497,26.2565167 13.9163298,26.1912711 14.3847031,26.6004958 L23.7048915,34.7436856 C38.5717726,24.5654461 44.1220586,15.9218386 40.8632807,8.87062903 C37.5538735,1.70986981 32.2703071,1.03840333 24.2632487,6.9920757 C23.8709427,7.28377594 23.3431752,7.27642035 22.9584452,6.97389037 C17.4144443,2.61440055 12.9537844,1.921539 9.35388183,4.66651884 C5.74010083,7.42208119 4.91618622,11.9140494 6.98844971,18.4320942 C7.18098742,19.0376974 6.86752143,19.6918287 6.28830383,19.8931371 L6.1924386,19.9196667 L15.8742433,19.9198831 L18.9682484,13.601862 C19.4585934,12.6005677 20.9419353,12.8027591 21.1464018,13.8987618 L22.9044525,23.322445 L26.4417058,18.1057306 C26.657171,17.7879642 27.0161346,17.5976608 27.4000626,17.5976608 L32.5175439,17.5976608 C33.1570314,17.5976608 33.6754386,18.116068 33.6754386,18.7555556 C33.6754386,19.3950432 33.1570314,19.9134503 32.5175439,19.9134503 L28.0139169,19.9134503 L23.2409382,26.9526027 C22.6604032,27.8087714 21.3340318,27.5320132 21.1443249,26.515127 L19.5108678,17.7593017 L17.6363881,21.5870269 C17.4419817,21.9840087 17.0385188,22.2356725 16.5964912,22.2356725 L1.83333333,22.2356725 C1.19384573,22.2356725 0.675438597,21.7172655 0.675438597,21.0777777 C0.675438597,20.4382901 1.19384573,19.9198831 1.83333333,19.9198831 L5.68591077,19.9214221 C5.32550383,19.8321555 5.0163317,19.5555725 4.89091724,19.161097 C2.5424174,11.7741853 3.5604875,6.22368489 8.05143927,2.7992666 C12.3999783,-0.516559811 17.66284,0.162431667 23.6398134,4.63045021 C32.3421894,-1.55524277 38.9786646,-0.519061038 42.8534903,7.8651274 Z",
    id: "Icon-colour"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPan);
export default __webpack_public_path__ + "static/media/Icon-pan.a4e5394ca294a147283df7b77484bf15.svg";
export { ForwardRef as ReactComponent };